module.exports = __webpack_public_path__ + "img/3938458.jpg";